/**
 * Secret Spice Co — Quiz Popup
 * Product Data Map & Constants
 * v1.1.0 — added GA4 dataLayer + gtag + Meta Pixel event tracking (quiz_shown / started / question_answered / email_submitted / completed / dismissed / cta_clicked)
 * v1.2.0 — results-first flow: recommendations show immediately, email now gates the
 *          discount code + bundle offers on the results screen (email screen removed).
 *          Added rotating social-proof toasts. New event: quiz_results_viewed.
 */
var SSCQuiz = (function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // PRODUCTS
  // Maps product key → { name, handle } for all 12 SSC products
  // ---------------------------------------------------------------------------
  var PRODUCTS = {
    'garlic-pepper':    { name: 'Garlic Pepper',         handle: 'garlic-pepper' },
    'lemon-pepper':     { name: 'Lemon Pepper',          handle: 'lemon-pepper' },
    'chilli-garlic':    { name: 'Chilli Garlic',         handle: 'chilli-garlic-salt' },
    'texan-bbq':        { name: 'Texan BBQ',             handle: 'texan-bbq' },
    'aroma':            { name: 'Aroma',                 handle: 'aroma-spice' },
    'delhi':            { name: 'Delhi',                 handle: 'delhi' },
    'tagine':           { name: 'Tagine',                handle: 'tagine' },
    'smokin-tex-mex':   { name: 'Smokin\' Tex-Mex',     handle: 'smokin' },
    'herbalicious':     { name: 'Herbalicious',          handle: 'herbalicious' },
    'lemon-pepper-lf':  { name: 'Lemon Pepper (Low FODMAP)',   handle: 'lemon-pepper-low-fodmap' },
    'herbalicious-lf':  { name: 'Herbalicious (Low FODMAP)',   handle: 'herbalicious-low-fodmap' },
    'smokin-lf':        { name: 'Smokin\' (Low FODMAP)',       handle: 'smokin-low-fodmap' }
  };

  // ---------------------------------------------------------------------------
  // RESULTS_MAP
  // Maps dietary preference → cooking style → array of product keys
  // Three top-level keys: fodmap | saltbomb | saltfree
  // ---------------------------------------------------------------------------
  var RESULTS_MAP = {
    fodmap: {
      smoky: ['lemon-pepper-lf', 'herbalicious-lf', 'smokin-lf'],
      fresh: ['lemon-pepper-lf', 'herbalicious-lf', 'smokin-lf'],
      all:   ['lemon-pepper-lf', 'herbalicious-lf', 'smokin-lf']
    },
    saltbomb: {
      bbq:      ['texan-bbq', 'garlic-pepper', 'lemon-pepper', 'chilli-garlic'],
      spicy:    ['chilli-garlic', 'texan-bbq', 'garlic-pepper', 'lemon-pepper'],
      everyday: ['garlic-pepper', 'lemon-pepper', 'chilli-garlic', 'texan-bbq'],
      all:      ['garlic-pepper', 'chilli-garlic', 'lemon-pepper', 'texan-bbq']
    },
    saltfree: {
      curries: ['delhi', 'tagine', 'aroma', 'smokin-tex-mex'],
      roasts:  ['aroma', 'smokin-tex-mex', 'herbalicious', 'tagine'],
      herby:   ['herbalicious', 'aroma', 'tagine', 'delhi'],
      all:     ['aroma', 'delhi', 'tagine', 'smokin-tex-mex', 'herbalicious']
    }
  };

  // ---------------------------------------------------------------------------
  // BUNDLES
  // Curated bundles aligned to each dietary preference
  // ---------------------------------------------------------------------------
  var BUNDLES = {
    fodmap: {
      name:     'Low FODMAP Bundle',
      handle:   'low-fodmap-bundle',
      linkType: 'product'
    },
    saltbomb: {
      name:     'Salt Bomb Bundle',
      handle:   'salt-bombs',
      linkType: 'product'
    },
    saltfree: {
      name:     'Salt Free Bundle',
      handle:   '5-pack',
      linkType: 'product'
    }
  };

  // ---------------------------------------------------------------------------
  // ULTIMATE_BUNDLE
  // The all-in bundle — uses cart/add checkout URL with variant ID
  // ---------------------------------------------------------------------------
  var ULTIMATE_BUNDLE = {
    name:       'Ultimate Spice Lovers Bundle',
    variantId:  '44300483559601',
    checkoutUrl: '/cart/add?items[][id]=44300483559601&items[][quantity]=1&return_to=/checkout'
  };

  // ---------------------------------------------------------------------------
  // AROMA_UPSELL
  // Cross-sell upsell product shown to salt-free and fodmap result recipients
  // ---------------------------------------------------------------------------
  var AROMA_UPSELL = {
    name:   'Aroma',
    handle: 'aroma-spice',
    desc:   'A naturally gentle blend crafted without salt or high-FODMAP ingredients. Beautifully aromatic and versatile for everyday cooking.'
  };

  // ---------------------------------------------------------------------------
  // BYOB_URL
  // Build Your Own Bundle page
  // ---------------------------------------------------------------------------
  var BYOB_URL = '/pages/bundle-builder';

  // ---------------------------------------------------------------------------
  // COOKIE UTILITIES
  // ---------------------------------------------------------------------------
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function setSessionCookie(name, value) {
    // No expires = session cookie (cleared when browser closes)
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
  }

  // ---------------------------------------------------------------------------
  // QUIZ STATE
  // ---------------------------------------------------------------------------
  var state = {
    dietary:      null,
    salt:         null,
    cooking:      null,
    email:        null,
    discountCode: null
  };

  // ---------------------------------------------------------------------------
  // SCREEN IDs
  // ---------------------------------------------------------------------------
  var SCREENS = {
    welcomeD: 'ssc-screen-welcome-d',
    welcomeB:  'ssc-screen-welcome-b',
    dietary:   'ssc-screen-dietary',
    salt:      'ssc-screen-salt',
    cooking:   'ssc-screen-cooking',
    results:   'ssc-screen-results'
  };

  var screenHistory = [];

  // Computed recommendation data, set by renderResults() and reused by the
  // email-unlock step (renderOffers) so we don't recompute / re-parse.
  var resultsData = { productKeys: [], shopifyProducts: {}, variantIds: [], saltKey: null };

  // ---------------------------------------------------------------------------
  // SCREEN NAVIGATION
  // ---------------------------------------------------------------------------
  function showScreen(screenId) {
    var screens = document.querySelectorAll('.ssc-quiz__screen');
    for (var i = 0; i < screens.length; i++) {
      screens[i].classList.remove('active');
    }
    var target = document.getElementById(screenId);
    if (target) {
      target.classList.add('active');
    }
    // Scroll quiz container to top
    var quiz = document.querySelector('.ssc-quiz');
    if (quiz) quiz.scrollTop = 0;
    // Push current to history
    screenHistory.push(screenId);
  }

  function goBack() {
    // Pop current screen, then pop the one we want to go back to
    screenHistory.pop(); // remove current
    var prev = screenHistory.pop(); // remove target (showScreen will re-push it)
    if (prev) {
      showScreen(prev);
    }
  }

  function goNext() {
    var current = screenHistory[screenHistory.length - 1];

    if (current === SCREENS.dietary) {
      if (state.dietary === 'fodmap') {
        state.salt = 'fodmap';
        populateCookingOptions();
        showScreen(SCREENS.cooking);
      } else {
        showScreen(SCREENS.salt);
      }
    } else if (current === SCREENS.salt) {
      populateCookingOptions();
      showScreen(SCREENS.cooking);
    } else if (current === SCREENS.cooking) {
      // Results-first: go straight to the results screen in its locked state.
      // The email gate there unlocks the discount code + offers.
      renderResults();
    }
  }

  // ---------------------------------------------------------------------------
  // ANSWER SELECTION
  // ---------------------------------------------------------------------------
  function selectAnswer(btn) {
    var quizAnswer = btn.getAttribute('data-quiz-answer');
    var value = btn.getAttribute('data-value');

    // Set state
    if (quizAnswer && value !== null) {
      state[quizAnswer] = value;
      track('quiz_question_answered', { question: quizAnswer, answer: value });
    }

    // Toggle .selected on siblings within the same answer group
    var parent = btn.parentElement;
    if (parent) {
      var siblings = parent.querySelectorAll('[data-quiz-answer]');
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('selected');
      }
    }
    btn.classList.add('selected');

    // Enable the next button on this screen
    var activeScreen = document.querySelector('.ssc-quiz__screen.active');
    if (activeScreen) {
      var nextBtn = activeScreen.querySelector('[data-quiz-action="next"]');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    }
  }

  function populateCookingOptions() {
    var container = document.getElementById('ssc-cooking-answers');
    if (!container) return;
    container.innerHTML = '';

    var path = state.salt === 'fodmap' ? 'fodmap' : state.salt;

    var options = [];
    if (path === 'fodmap') {
      options = [
        { main: 'Smoky &amp; Bold',      sub: 'deep, smoky, full of flavour', value: 'smoky' },
        { main: 'Light &amp; Fresh',     sub: 'bright, zesty, easygoing',      value: 'fresh' },
        { main: 'A bit of everything',   sub: 'show me the lot.',              value: 'all'   }
      ];
    } else if (path === 'saltbomb') {
      options = [
        { main: 'BBQ &amp; Grilling',        sub: 'for the smoker, the grill, the weekend', value: 'bbq'      },
        { main: 'Bold &amp; Spicy',          sub: 'heat-first, no apologies',                value: 'spicy'    },
        { main: 'Classic Everyday Dinners',  sub: 'chicken, steak, roast veg',               value: 'everyday' },
        { main: 'A bit of everything',       sub: 'show me the lot.',                        value: 'all'      }
      ];
    } else if (path === 'saltfree') {
      options = [
        { main: 'Curries &amp; World Food',  sub: 'big spice, slow simmers, bold bases', value: 'curries'  },
        { main: 'Roasts &amp; Tray Bakes',   sub: 'trays, tins, and Sunday roasts',      value: 'roasts'   },
        { main: 'Light &amp; Herby',         sub: 'fresh, green, herb-forward',          value: 'herby'    },
        { main: 'A bit of everything',       sub: 'show me the lot.',                    value: 'all'      }
      ];
    }

    for (var i = 0; i < options.length; i++) {
      var btn = document.createElement('button');
      btn.className = 'ssc-quiz__answer';
      btn.setAttribute('data-quiz-answer', 'cooking');
      btn.setAttribute('data-value', options[i].value);
      btn.innerHTML =
        '<div class="ssc-quiz__marker" aria-hidden="true"></div>' +
        '<div class="ssc-quiz__answer-text">' +
          '<span class="ssc-quiz__answer-main">' + options[i].main + '</span>' +
          '<span class="ssc-quiz__answer-sub">' + options[i].sub + '</span>' +
        '</div>';
      container.appendChild(btn);
    }

    // Cooking is the LAST question in both paths now (results follow it, but
    // results is a reveal, not a numbered step). Standard = Step 3 of 3,
    // FODMAP (skips salt) = Step 2 of 2. Progress fills to 100% either way.
    var stepLabel = document.getElementById('ssc-cooking-step-label');
    if (stepLabel) {
      stepLabel.textContent = path === 'fodmap' ? 'Step 2 of 2' : 'Step 3 of 3';
    }

    var cookingScreen = document.getElementById(SCREENS.cooking);
    if (cookingScreen) {
      var progressFill = cookingScreen.querySelector('.ssc-quiz__progress-fill');
      if (progressFill) {
        progressFill.style.width = '100%';
      }
    }

    // Reset cooking state and disable next button
    state.cooking = null;
    var activeScreen = document.getElementById(SCREENS.cooking);
    if (activeScreen) {
      var nextBtn = activeScreen.querySelector('[data-quiz-action="next"]');
      if (nextBtn) nextBtn.setAttribute('disabled', 'disabled');
    }
  }

  // ---------------------------------------------------------------------------
  // RESULTS RENDERING
  // ---------------------------------------------------------------------------
  // Add all recommended products to cart via Shopify AJAX API
  function addAllToCart(variantIds, btn) {
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    track('quiz_cta_clicked', {
      cta_type: 'add_all_to_cart',
      variant_count: variantIds.length,
      dietary: state.dietary, salt: state.salt, cooking: state.cooking,
    });

    var items = variantIds.map(function (id) {
      return { id: Number(id), quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function () {
      btn.textContent = 'Added to Cart!';
      btn.style.background = '#2d7a3a';
      // Redirect to cart after short delay
      setTimeout(function () {
        closeQuiz();
        window.location.href = '/cart';
      }, 800);
    })
    .catch(function () {
      btn.textContent = 'Error, try again';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = originalText; }, 2000);
    });
  }

  // Parse the server-rendered product data JSON once.
  function parseShopifyProducts() {
    var el = document.getElementById('ssc-quiz-product-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent || el.innerHTML); } catch (e) { return {}; }
  }

  // Compute recommended product keys + variant ids for the current answers.
  function computeResults() {
    var shopifyProducts = parseShopifyProducts();
    var saltKey    = state.salt === 'fodmap' ? 'fodmap' : state.salt;
    var cookingKey = state.cooking;
    var productKeys = [];
    if (RESULTS_MAP[saltKey] && RESULTS_MAP[saltKey][cookingKey]) {
      productKeys = RESULTS_MAP[saltKey][cookingKey];
    }
    var variantIds = [];
    for (var j = 0; j < productKeys.length; j++) {
      var prod = PRODUCTS[productKeys[j]];
      if (!prod) continue;
      var sd = shopifyProducts[prod.handle] || {};
      if (sd.variantId) variantIds.push(sd.variantId);
    }
    resultsData = {
      productKeys: productKeys,
      shopifyProducts: shopifyProducts,
      variantIds: variantIds,
      saltKey: saltKey
    };
    return resultsData;
  }

  // Render the recommended blend cards. Locked (pre-email) = display-only
  // <div>s; after unlock = clickable <a> links to the product pages.
  function renderRecCards(clickable) {
    var productsContainer = document.getElementById('ssc-results-products');
    if (!productsContainer) return;
    var productKeys = resultsData.productKeys;
    var shopifyProducts = resultsData.shopifyProducts;
    var html = '';
    for (var i = 0; i < productKeys.length; i++) {
      var key = productKeys[i];
      var product = PRODUCTS[key];
      if (!product) continue;
      var shopifyData = shopifyProducts[product.handle] || {};
      var imgUrl = shopifyData.image || '';
      var inner =
        '<div class="ssc-quiz__product-img">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="' + product.name + '">' : '') +
        '</div>' +
        '<div class="ssc-quiz__result-info">' +
          '<h3>' + product.name + '</h3>' +
        '</div>';
      if (clickable) {
        html += '<a href="/products/' + product.handle + '" class="ssc-quiz__result-card" style="text-decoration:none !important;">' + inner + '</a>';
      } else {
        html += '<div class="ssc-quiz__result-card ssc-quiz__result-card--locked">' + inner + '</div>';
      }
    }
    productsContainer.innerHTML = html;
  }

  // Show the results screen with recommendations visible and the discount
  // code + offers locked behind the email gate. No Klaviyo/email tracking
  // here — that fires on unlock (submitEmail).
  function renderResults() {
    computeResults();
    renderRecCards(false);

    // Gate visible, offers hidden, fields reset
    var gate   = document.getElementById('ssc-results-gate');
    var offers = document.getElementById('ssc-results-offers');
    if (gate)   gate.classList.remove('is-hidden');
    if (offers) offers.classList.remove('is-revealed');

    var emailInput = document.getElementById('ssc-quiz-email');
    if (emailInput) emailInput.value = '';
    var submitBtn = document.querySelector('#ssc-results-gate [data-quiz-action="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = 'Unlock My Discount';
    }

    showScreen(SCREENS.results);

    var productNames = resultsData.productKeys.map(function (k) {
      return PRODUCTS[k] ? PRODUCTS[k].name : k;
    });
    track('quiz_results_viewed', {
      dietary: state.dietary,
      salt: state.salt,
      cooking: state.cooking,
      recommended_count: productNames.length,
      recommended_products: productNames.join(','),
    });

    wireCtaTracking();
  }

  // Reveal the discount code + bundle offers after the visitor submits email.
  function renderOffers(discountCode) {
    state.discountCode = discountCode;
    var shopifyProducts = resultsData.shopifyProducts;
    var productKeys     = resultsData.productKeys;
    var variantIds      = resultsData.variantIds;
    var saltKey         = resultsData.saltKey;

    // Send discount code to Klaviyo now that we have it
    if (state.email && discountCode) {
      var discountPayload = {
        data: {
          type: 'profile',
          attributes: {
            email: state.email,
            properties: { quiz_discount_code: discountCode }
          }
        }
      };
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
        body: JSON.stringify(discountPayload)
      }).catch(function () {});
    }

    // Recommendation cards become clickable links to PDPs
    renderRecCards(true);

    // Discount code text
    var discountEl = document.getElementById('ssc-discount-code');
    if (discountEl) discountEl.textContent = discountCode || '';

    // Add "Add All to Cart" button (inside the now-revealed offers area)
    var addAllWrap = document.getElementById('ssc-results-addall');
    if (addAllWrap) {
      addAllWrap.innerHTML = '';
      if (variantIds.length > 0) {
        var addBtn = document.createElement('button');
        addBtn.className = 'ssc-quiz__cta-btn';
        addBtn.textContent = 'Add All ' + variantIds.length + ' to Cart';
        addBtn.style.marginTop = '4px';
        addBtn.setAttribute('data-variant-ids', variantIds.join(','));
        addBtn.addEventListener('click', function () {
          addAllToCart(variantIds, this);
        });
        addAllWrap.appendChild(addBtn);

        // Clarify the auto-applied bundle tier so the customer knows the cart
        // beats the 10% code at 4+ items (10% / 15% / 20% tiers).
        var n = variantIds.length;
        var noteText = '';
        if (n >= 8)      noteText = 'Saves you 20% automatically at checkout, the more you add the more you save';
        else if (n >= 4) noteText = 'Saves you 15% automatically at checkout, better than the code on 4+ items';
        if (noteText) {
          var note = document.createElement('p');
          note.className = 'ssc-quiz__addall-note';
          note.textContent = noteText;
          addAllWrap.appendChild(note);
        }
      }
    }

    // Build BYOB link with preselected handles
    var byobLink = document.getElementById('ssc-byob-link');
    if (byobLink) {
      var handles = productKeys.map(function (k) {
        return PRODUCTS[k] ? PRODUCTS[k].handle : k;
      });
      byobLink.setAttribute('href', BYOB_URL + '?preselect=' + handles.join(','));
    }

    // Render matching bundle
    var bundleContainer = document.getElementById('ssc-matching-bundle');
    if (bundleContainer) {
      var bundle = BUNDLES[saltKey];
      if (bundle) {
        var bundleShopify = shopifyProducts[bundle.handle] || {};
        var bundleImgHtml = bundleShopify.image
          ? '<div class="ssc-quiz__product-img"><img src="' + bundleShopify.image + '" alt="' + bundle.name + '"></div>'
          : '<div class="ssc-quiz__bundle-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18"/><path d="M12 8c-2-4-6-4-6 0M12 8c2-4 6-4 6 0"/></svg></div>';
        bundleContainer.innerHTML =
          '<a href="/products/' + bundle.handle + '" class="ssc-quiz__bundle-offer">' +
            bundleImgHtml +
            '<div class="ssc-quiz__bundle-info">' +
              '<h3>' + bundle.name + '</h3>' +
              '<p>Save with bundle pricing</p>' +
            '</div>' +
            '<div class="ssc-quiz__bundle-arrow">&rarr;</div>' +
          '</a>';
      }
    }

    // Render upsell section
    var upsellSection = document.getElementById('ssc-upsell-section');
    if (upsellSection) {
      upsellSection.innerHTML = '';
      if (saltKey === 'fodmap') {
        // Aroma upsell
        var aromaShopify = shopifyProducts[AROMA_UPSELL.handle] || {};
        upsellSection.innerHTML =
          '<div class="ssc-quiz__divider">you might also love</div>' +
          '<a href="/products/' + AROMA_UPSELL.handle + '" class="ssc-quiz__bundle-offer">' +
            '<div class="ssc-quiz__product-img">' +
              (aromaShopify.image ? '<img src="' + aromaShopify.image + '" alt="' + AROMA_UPSELL.name + '">' : '') +
            '</div>' +
            '<div class="ssc-quiz__bundle-info">' +
              '<h3>' + AROMA_UPSELL.name + '</h3>' +
              '<p>' + AROMA_UPSELL.desc + '</p>' +
            '</div>' +
            '<div class="ssc-quiz__bundle-arrow">&rarr;</div>' +
          '</a>';
      } else {
        // Ultimate Bundle — direct to checkout
        upsellSection.innerHTML =
          '<div class="ssc-quiz__divider">go all in</div>' +
          '<a href="' + ULTIMATE_BUNDLE.checkoutUrl + '" class="ssc-quiz__ultimate-offer">' +
            '<h3>' + ULTIMATE_BUNDLE.name + '</h3>' +
            '<p>All 9 blends, the complete Secret Spice Co pantry</p>' +
            '<span class="ssc-quiz__save-tag">SAVE 20% automatic at checkout</span>' +
          '</a>';
      }
    }

    // Reveal offers, hide the gate
    var gate   = document.getElementById('ssc-results-gate');
    var offers = document.getElementById('ssc-results-offers');
    if (gate)   gate.classList.add('is-hidden');
    if (offers) offers.classList.add('is-revealed');
  }

  // Wire CTA click tracking across the whole results screen (attach once).
  function wireCtaTracking() {
    var resultsScreen = document.getElementById(SCREENS.results);
    if (!resultsScreen || resultsScreen.dataset.ctaTracked) return;
    resultsScreen.dataset.ctaTracked = '1';
    resultsScreen.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var ctaType = 'unknown';
      if (link.id === 'ssc-byob-link')                              ctaType = 'build_your_own_bundle';
      else if (link.classList.contains('ssc-quiz__ultimate-offer')) ctaType = 'ultimate_bundle';
      else if (link.classList.contains('ssc-quiz__bundle-offer'))   ctaType = 'matched_bundle_or_upsell';
      else if (link.classList.contains('ssc-quiz__result-card'))    ctaType = 'product_card';
      track('quiz_cta_clicked', {
        cta_type: ctaType,
        destination: href,
        dietary: state.dietary, salt: state.salt, cooking: state.cooking,
      });
    });
  }

  // ---------------------------------------------------------------------------
  // ANALYTICS — GA4 (dataLayer + gtag) and Meta Pixel
  // ---------------------------------------------------------------------------
  function track(eventName, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName, event_category: 'spice_quiz' }, params));
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, Object.assign({ event_category: 'spice_quiz' }, params));
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') {
        var pixelName = eventName === 'quiz_completed' ? 'CompleteRegistration' :
                        eventName === 'quiz_email_submitted' ? 'Lead' :
                        eventName === 'quiz_shown' ? 'ViewContent' : null;
        if (pixelName) window.fbq('track', pixelName, Object.assign({ content_category: 'spice_quiz', content_name: eventName }, params));
        window.fbq('trackCustom', 'SSC_' + eventName, params);
      }
    } catch (e) {}
  }

  // ---------------------------------------------------------------------------
  // API INTEGRATIONS
  // ---------------------------------------------------------------------------
  var KLAVIYO_PUBLIC_KEY  = 'R8bCgW';
  var KLAVIYO_LIST_ID     = 'VtTcva';
  var DISCOUNT_CODE = 'SPICEQUIZ10';

  // Email unlock: validates the email on the results screen, fires Klaviyo +
  // analytics, then reveals the discount code + offers (renderOffers).
  function submitEmail() {
    var emailInput = document.getElementById('ssc-quiz-email');
    if (!emailInput) return;
    var email = emailInput.value.trim();
    if (!email || email.indexOf('@') === -1) return;

    state.email = email;

    // Disable + relabel the unlock button to prevent double submission
    var submitBtn = document.querySelector('#ssc-results-gate [data-quiz-action="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = 'Unlocking…';
    }

    // Recommended products (already computed when results rendered)
    var productKeys = resultsData.productKeys || [];
    var productNames = productKeys.map(function (k) {
      return PRODUCTS[k] ? PRODUCTS[k].name : k;
    });

    // Send to Klaviyo: profile update, list subscribe, and Quiz Completed event
    sendToKlaviyo(email, productNames).catch(function () {});
    trackQuizCompleted(email, productNames);

    // GA4 + Pixel
    track('quiz_email_submitted', {});
    track('quiz_completed', {
      dietary: state.dietary,
      salt: state.salt,
      cooking: state.cooking,
      recommended_count: productNames.length,
      recommended_products: productNames.join(','),
      discount_code: DISCOUNT_CODE,
    });

    // Mark completed and reveal the offers in place
    setCookie('ssc_quiz_completed', '1', 14);
    setCookie('ssc_quiz_dismissed', '1', 7);
    renderOffers(DISCOUNT_CODE);
  }

  function sendToKlaviyo(email, recommendedProductNames) {
    var payload = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            quiz_dietary:              state.dietary,
            quiz_salt:                 state.salt,
            quiz_cooking:              state.cooking,
            quiz_completed_date:       new Date().toISOString(),
            quiz_recommended_products: recommendedProductNames.join(',')
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-12-15'
      },
      body: JSON.stringify(payload)
    }).then(function () {
      // Fix 7: Subscribe to Klaviyo list
      var subscribePayload = {
        data: {
          type: 'subscription',
          attributes: {
            list_id: KLAVIYO_LIST_ID,
            email: email,
            custom_source: 'Quiz Popup'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify(subscribePayload)
      });
    });
  }

  // Fire "Quiz Completed" event to Klaviyo — used as flow trigger
  function trackQuizCompleted(email, productNames) {
    var saltKey = state.salt === 'fodmap' ? 'fodmap' : state.salt;
    var bundleName = BUNDLES[saltKey] ? BUNDLES[saltKey].name : '';
    var payload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } },
          properties: {
            dietary: state.dietary,
            salt_preference: state.salt,
            cooking_style: state.cooking,
            recommended_products: productNames.join(', '),
            recommended_bundle: bundleName,
            discount_code: DISCOUNT_CODE
          }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  // ---------------------------------------------------------------------------
  // SOCIAL-PROOF TOASTS
  // Rotating "X from STATE just unlocked their match" notifications. Shown on
  // every screen EXCEPT results, every 8–10s, shuffled so no repeat per session.
  // ---------------------------------------------------------------------------
  var PROOF = [
    { name: 'Sarah',  state: 'QLD', pronoun: 'her'  },
    { name: 'Deb',    state: 'ACT', pronoun: 'her'  },
    { name: 'James',  state: 'NSW', pronoun: 'his'  },
    { name: 'Mia',    state: 'VIC', pronoun: 'her'  },
    { name: 'Tom',    state: 'SA',  pronoun: 'his'  },
    { name: 'Olivia', state: 'WA',  pronoun: 'her'  },
    { name: 'Jack',   state: 'NSW', pronoun: 'his'  },
    { name: 'Chloe',  state: 'TAS', pronoun: 'her'  },
    { name: 'Liam',   state: 'QLD', pronoun: 'his'  },
    { name: 'Emma',   state: 'VIC', pronoun: 'her'  },
    { name: 'Noah',   state: 'NT',  pronoun: 'his'  },
    { name: 'Ava',    state: 'SA',  pronoun: 'her'  },
    { name: 'Ben',    state: 'WA',  pronoun: 'his'  },
    { name: 'Grace',  state: 'ACT', pronoun: 'her'  }
  ];

  var proofDeck = [];
  var proofTimer = null;

  function shuffleProofDeck() {
    proofDeck = PROOF.slice();
    for (var i = proofDeck.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = proofDeck[i]; proofDeck[i] = proofDeck[j]; proofDeck[j] = t;
    }
  }

  function nextProof() {
    if (!proofDeck.length) shuffleProofDeck();
    return proofDeck.pop();
  }

  function showProofToast() {
    var toast = document.getElementById('ssc-quiz-proof-toast');
    if (!toast) return;
    // Suppress on the results screen so nothing competes with the unlock CTA
    var active = document.querySelector('.ssc-quiz__screen.active');
    if (active && active.id === SCREENS.results) return;
    var p = nextProof();
    toast.innerHTML =
      '<span class="ssc-quiz__proof-toast-dot" aria-hidden="true"></span>' +
      '<span class="ssc-quiz__proof-toast-text"><strong>' + p.name + ' from ' + p.state +
      '</strong> just unlocked ' + p.pronoun + ' match</span>';
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 4000);
  }

  function startProofLoop() {
    stopProofLoop();
    shuffleProofDeck();
    var tick = function () {
      showProofToast();
      var delay = 8000 + Math.floor(Math.random() * 2000); // 8–10s
      proofTimer = setTimeout(tick, delay);
    };
    proofTimer = setTimeout(tick, 2500); // first toast ~2.5s in, not instant
  }

  function stopProofLoop() {
    if (proofTimer) { clearTimeout(proofTimer); proofTimer = null; }
    var toast = document.getElementById('ssc-quiz-proof-toast');
    if (toast) toast.classList.remove('show');
  }

  // ---------------------------------------------------------------------------
  // TRIGGER LOGIC & INIT
  // ---------------------------------------------------------------------------
  function shouldShowQuiz() {
    if (getCookie('ssc_quiz_purchased')) return false;
    if (getCookie('ssc_quiz_completed')) return false;
    if (getCookie('ssc_quiz_dismissed'))  return false;
    return true;
  }

  function isProductPage() {
    return /^\/products\//.test(window.location.pathname);
  }

  function getWelcomeScreen() {
    return getCookie('ssc_quiz_completed') ? SCREENS.welcomeB : SCREENS.welcomeD;
  }

  var scrollY = 0;

  function openQuiz() {
    screenHistory = [];
    scrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.add('ssc-quiz-open');
    document.body.style.top = '-' + scrollY + 'px';
    var overlay = document.getElementById('ssc-quiz-overlay');
    if (overlay) overlay.classList.add('active');
    showScreen(getWelcomeScreen());
    startProofLoop();
    track('quiz_shown', {
      page_path: window.location.pathname,
      trigger_type: isProductPage() ? 'pdp_timeout' : 'sitewide_timeout_or_exit',
    });
  }

  function closeQuiz() {
    var lastScreen = screenHistory[screenHistory.length - 1] || null;
    var completed = !!getCookie('ssc_quiz_completed');
    var overlay = document.getElementById('ssc-quiz-overlay');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('ssc-quiz-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    stopProofLoop();
    setCookie('ssc_quiz_dismissed', '1', 7);
    if (!completed) {
      track('quiz_dismissed', { last_screen: lastScreen });
    }
  }

  function init() {
    // Event delegation + input listeners must ALWAYS bind so the on-page
    // "Take the quiz" trigger (window.SSCQuiz.open) has working controls even
    // when the auto-popup is suppressed by a cookie. Only the auto-trigger
    // (timeout + exit-intent) is gated by shouldShowQuiz() — see below.
    var overlay = document.getElementById('ssc-quiz-overlay');
    if (!overlay) return;

    overlay.addEventListener('click', function (e) {
      var target = e.target;

      // Close on overlay background click (not on quiz content)
      if (target === overlay) {
        closeQuiz();
        return;
      }

      // Walk up the DOM to find a data-quiz-action or data-quiz-answer element
      var el = target;
      while (el && el !== overlay) {
        // Handle actions
        var action = el.getAttribute('data-quiz-action');
        if (action) {
          e.preventDefault();
          if (action === 'open')    openQuiz();
          if (action === 'start')   { showScreen(SCREENS.dietary); track('quiz_started', {}); }
          if (action === 'dismiss') closeQuiz();
          if (action === 'close')   closeQuiz();
          if (action === 'next')    goNext();
          if (action === 'back')    goBack();
          if (action === 'submit')  submitEmail();
          break;
        }

        // Handle answer selection
        var quizAnswer = el.getAttribute('data-quiz-answer');
        if (quizAnswer) {
          e.preventDefault();
          selectAnswer(el);
          break;
        }

        el = el.parentElement;
      }
    });

    // Email input validation — enable submit if input contains @
    var emailInput = document.getElementById('ssc-quiz-email');
    var submitBtn  = document.querySelector('[data-quiz-action="submit"]');
    if (emailInput && submitBtn) {
      emailInput.addEventListener('input', function () {
        if (emailInput.value.indexOf('@') !== -1) {
          submitBtn.removeAttribute('disabled');
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
        }
      });
    }

    // ---- Auto-trigger (timeout + exit-intent) ----
    // EOFY SALE: auto-popup disabled so it doesn't compete with the EOFY
    // hero/announcement bar. Flip to true after the sale to restore auto-popup.
    // This flag ONLY gates the auto-popup. The click listener + manual open
    // (window.SSCQuiz.open / "Take the quiz") are bound above and ALWAYS work.
    var AUTO_TRIGGER_ENABLED = false;

    if (AUTO_TRIGGER_ENABLED && shouldShowQuiz()) {
      var triggered = false;
      var onPDP = isProductPage();

      // Timeout trigger — 30s on product pages, 8s elsewhere
      var delayMs = onPDP ? 30000 : 8000;
      var timeoutId = setTimeout(function () {
        if (!triggered) {
          triggered = true;
          openQuiz();
        }
      }, delayMs);

      // Exit-intent — disabled on product pages so it doesn't interrupt ATC flow
      if (!onPDP) {
        var onExitIntent = function (e) {
          if (e.clientY <= 0 && !triggered) {
            triggered = true;
            clearTimeout(timeoutId);
            document.removeEventListener('mouseleave', onExitIntent);
            openQuiz();
          }
        };
        document.addEventListener('mouseleave', onExitIntent);
      }
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ---------------------------------------------------------------------------
  // Public API
  // ---------------------------------------------------------------------------
  return {
    PRODUCTS:        PRODUCTS,
    RESULTS_MAP:     RESULTS_MAP,
    BUNDLES:         BUNDLES,
    ULTIMATE_BUNDLE: ULTIMATE_BUNDLE,
    AROMA_UPSELL:    AROMA_UPSELL,
    BYOB_URL:        BYOB_URL,
    open:            openQuiz,
    close:           closeQuiz
  };
}());
